export const DOCUMENT_SERVER_SIDE_SORTABLE_FIELDS = new Set<string>([
  "entryNo",
  "documentDate",
  "documentNo",
  "vendorName",
  "amountGross",
  "dueDate",
  "paymentMethod",
  "paymentStatus",
  "status",
  "assignedUserEmail",
  "processedExternally",
  "processed",
]);

export const DOCUMENT_SERVER_SIDE_FILTERABLE_FIELDS = new Set<string>([
  "entryNo",
  "documentDate",
  "documentNo",
  "vendorName",
  "amountGross",
  "dueDate",
  "paymentMethod",
  "paymentStatus",
  "status",
  "assignedUserEmail",
  "processedExternally",
  "processed",
]);

export const DOCUMENT_SERVER_SIDE_DISABLED_FIELDS = new Set<string>([
  "vendorVatReg",
  "currency",
  "ksefNo",
  "purchaseCost",
]);

export function isDocumentServerSideSortable(field: string): boolean {
  return DOCUMENT_SERVER_SIDE_SORTABLE_FIELDS.has(field);
}

export function isDocumentServerSideFilterable(field: string): boolean {
  return DOCUMENT_SERVER_SIDE_FILTERABLE_FIELDS.has(field);
}
